<template>
  <div class="d-flex justify-content-end">
    <div class="input-group mb-4" style="max-width: 400px; width: 100%">
      <input
        type="text"
        class="form-control"
        :placeholder="placeholder"
        :value="value"
        @keyup="$emit('input', $event.target.value)"
        @keyup.enter="$emit('enter')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "InputSearch",
  props: {
    value: String,
    placeholder: {
      type: String,
      default: "Search...",
    },
  },
};
</script>
